<script setup lang="ts">

interface Props {
    label: string
}

const props = defineProps<Props>()
</script>

<template>
    <v-list-item
        density="compact"
        class="px-0"
        nav
    >
        <p class="font-weight-bold text-body-2 mb-1">
            {{ props.label }}
        </p>
        <slot />
    </v-list-item>
</template>

<style scoped>

</style>
